import { render, staticRenderFns } from "./ShangWU.vue?vue&type=template&id=68a9dc86&scoped=true&"
import script from "./ShangWU.vue?vue&type=script&lang=js&"
export * from "./ShangWU.vue?vue&type=script&lang=js&"
import style0 from "./ShangWU.vue?vue&type=style&index=0&id=68a9dc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9dc86",
  null
  
)

export default component.exports